export default function jumpPage (vi) {
  let vid = vi.jumpDefaultParam[0].value
  // jumpID是3605就是学习计划，3602是单视频
  let isPlan = vi.jumpId == 3605
  let url = ''
  // 学习计划
  let jumpParamPlan = vi.jumpDefaultParam
  let planid = ''
  let videoid = ''
  if (isPlan) {
    jumpParamPlan.forEach(val => {
      if (val.key == 'planid') {
        planid = val.value
      }
      if (val.key == 'videoid') {
        videoid = val.value
      }
    })
    if (videoid) {
      url = `/p/1/${planid}?resourceId=${videoid}&materialType=0&cxid=1s6lhj7va`
    } else {
      url = `/p/1/${planid}?cxid=1s6lhj7va`
    }
  } else {
    url = `/v/2/${vid}?cxid=2fvxf8uus`
  }
  return url
}


// WEBPACK FOOTER //
// ./src/utils/utils.js